import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PlaceholderImage from "src/components/Placeholder";
import { theme } from "styled-tools";
import { Link } from "react-router-dom";

function AviatorMissionPromo(props: any) {
  const {
    app: { brandId },
    theme,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <InformationWrapper>
        {/* =========================
            TOP CONTENT
        ========================== */}
        <TopSection>
          <ImageWrapper>
            <LazyLoadImage
              src={`${config.imageV3Host}/static/cashsite/${theme.image.aviatorMissionHowToClaim}`}
              alt="How To Claim"
              effect="none"
              placeholder={<PlaceholderImage />}
            />
          </ImageWrapper>
        </TopSection>

        <Section>
          <StepsImageWrapper>
            <Link to="/instant-games/spribe/aviator-1">
              <LazyLoadImage
                src={`${config.imageV3Host}/static/cashsite/${theme.image.aviatorMissionSteps01}`}
                alt="Steps"
                effect="none"
                placeholder={<PlaceholderImage />}
              />
            </Link>
            <LazyLoadImage
              src={`${config.imageV3Host}/static/cashsite/${theme.image.aviatorMissionSteps02}`}
              alt="Steps"
              effect="none"
              placeholder={<PlaceholderImage />}
            />
            <LazyLoadImage
              src={`${config.imageV3Host}/static/cashsite/${theme.image.aviatorMissionSteps03}`}
              alt="Steps"
              effect="none"
              placeholder={<PlaceholderImage />}
            />
            <LazyLoadImage
              src={`${config.imageV3Host}/static/cashsite/${theme.image.aviatorMissionSteps04}`}
              alt="Steps"
              effect="none"
              placeholder={<PlaceholderImage />}
            />
            <LazyLoadImage
              src={`${config.imageV3Host}/static/cashsite/${theme.image.aviatorMissionSteps05}`}
              alt="Steps"
              effect="none"
              placeholder={<PlaceholderImage />}
            />
          </StepsImageWrapper>
        </Section>

        <SectionRibbonFS>
          Your Mission. Your Flight. Your Reward!
        </SectionRibbonFS>

        {/* =========================
            TERMS & CONDITIONS
        ========================== */}
        <Section>
          <h2>Terms & Conditions</h2>

          <TermsList>
            <li>
              The promotion run from.{" "}
              <strong>1st November to 31st December.</strong>
            </li>

            <li>
              Players{" "}
              <strong>
                must join Mission Aviator and complete all mission{" "}
                requirements{" "}
              </strong>{" "}
              before the mission ends.
            </li>

            <li>
              Each bet must have a minimum stake of <strong>₹50.</strong>
            </li>

            <li>
              Players must complete all three requirements:{" "}
              <strong>
                place 25 bets, achieve 25 wins, and reach a 25x multiplier{" "}
              </strong>
            </li>

            <li>
              Players can track their mission progress in the Aviator game
              lobby.
            </li>

            <li>
              Upon successful completion, players must click{" "}
              <strong>“Take Prize”</strong> to claim their reward.
            </li>

            <li>
              The assured Free Bet reward will range{" "}
              <strong> from ₹50-₹500 </strong>, divided into 5 equal Free Bets.
            </li>

            <li>
              The reward will be automatically credited after clicking “Take
              Prize” and will appear in the Free Bets section.
            </li>
            <li>
              Only winnings generated from Free Bets will be credited to the
              player's account. The Free Bet stake itself is non-withdrawable.
            </li>
            <li>
              Only real-money bets count toward mission progress. Bets placed
              using bonus funds do not count.
            </li>
            <li>
              Mission progress may be paused due to technical issues or
              unforeseen circumstances. Actions taken while the mission is
              paused will not count toward completion.
            </li>
            <li>
              All qualifying bets must comply with the mission rules and
              applicable timeframes.
            </li>
            <li>
              The operator reserves the right to cancel the mission due to
              technical issues or other unforeseen circumstances.
            </li>
            <li>
              The operator may distribute prizes at its discretion, in
              accordance with the platform's terms and conditions.
            </li>
          </TermsList>
        </Section>
      </InformationWrapper>
    </>
  );
}

export default withTheme(withAppContext(AviatorMissionPromo));

/* =========================================================
   MAIN WRAPPER
========================================================= */

const InformationWrapper = styled.div`
  width: calc(100% - 2.4em);
  min-height: 100vh;
  height: auto;
  padding: 1rem 0 4rem;
  margin: 0 1.2em;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url(${config.imageV3Host}/static/cashsite/${theme("image.aviatorMissionInnerBg",)});
  background-position: bottom center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
  color: #fff;

  h1,
  h2,
  p {
    margin: 0;
    padding: 0;
  }

  h1,
  h2 {
    color: ${theme("palette.aviatorMissionHead")};
    text-align: center;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  h1 {
    font-size: 17px;
    text-transform: uppercase;
  }

  h2 {
    font-size: 17px;
    text-transform: capitalize;
  }

  @media (max-width: 768px) {
    padding: 12px 10px 30px;
    gap: 12px;

    h1 {
      font-size: 15px;
      line-height: 22px;
    }

    h2 {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 14px;
      line-height: 21px;
    }

    h2 {
      font-size: 15px;
    }
  }
`;

/* =========================================================
   TOP SECTION
========================================================= */

const TopSection = styled.div`
  width: 75%;
  max-width: 1640px;
  min-height: 150px;
  padding: 0px 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  box-sizing: border-box;

  .top-para {
    width: 100%;
    max-width: 880px;
    color: #555555;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    text-transform: none;
  }

  .top-para strong {
    color: #404040;
    font-weight: 700;
  }

  .promotion-period {
    color: #555555;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
  }

  .promotion-period strong {
    color: #404040;
    font-weight: 700;
  }

  @media (max-width: 992px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-height: auto;
    padding: 25px 18px;
    gap: 14px;

    .top-para,
    .promotion-period {
      font-size: 13px;
      line-height: 20px;
    }

    .desktop-break {
      display: none;
    }
  }
`;

/* =========================================================
   COMMON WHITE SECTION
========================================================= */

const Section = styled.section`
  width: 75%;
  max-width: 1640px;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  @media (max-width: 992px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 30px 15px;
  }
`;

/* =========================================================
   HOW TO CLAIM
========================================================= */

const ImageWrapper = styled.div`
  width: 100%;
  margin: 5px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  img {
    width: 100%;
    height: auto;

    display: block;
  }

  @media (max-width: 992px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;

    margin-top: 20px;
  }
`;

/* =========================================================
   TERMS & CONDITIONS
========================================================= */

const TermsList = styled.ul`
  width: 70%;
  max-width: 750px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  margin: 25px auto 0;
  padding: 0;
  list-style: none;

  li {
    position: relative;
    color: #ffffff;
    background: ${theme("palette.aviatorMissionTermsBg")};

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    text-align: left;
    line-height: 21px;
    padding: 9px 16px 9px 36px;
    box-sizing: border-box;
    text-transform: none;
  }

  li::before {
    content: "✦";
    position: absolute;
    left: 18px;
    top: 9px;
    color: #ffffff;
    font-size: 11px;
  }

  li strong {
    color: #ffffff;
    font-weight: 700;
  }

  @media (max-width: 992px) {
    width: 65%;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 20px;

    li {
      font-size: 13px;
      line-height: 20px;
      padding: 9px 12px 9px 31px;
    }

    li::before {
      left: 13px;
      top: 9px;
    }
  }

  @media (max-width: 480px) {
    li {
      font-size: 12px;
      line-height: 19px;
    }
  }
`;

const SectionRibbonFS = styled.div`
  width: 100%;
  height: auto;
  min-height: 71px;
  background: rgba(230, 53, 56, 0.3);
  color: #fff;
  text-align: center;
  font-size: 25px;
  font-style: normal;
  font-weight: 900;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0px;
  letter-spacing: 0.4px;
`;

export const StepsImageWrapper = styled.div`
  width: 90%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;

  

  span,a {
    width: 32%;

    & img {
      width: 100%;
    }
  }

  a {
    span {
      width: 100%;
    }
  }
`